import type { Destination } from '../destination';
import { lazySdk } from '../lazy-sdk';
import { toVendorEvent } from '../mapping';

/**
 * TikTok Pixel: `screen_view` is the pixel's page view, every other event is
 * tracked under its own name with the row as its data. Pass-through: no
 * insights guarantee.
 */
export function createTiktokPixelDestination(pixelId: string): Destination {
	const pixel = lazySdk(
		() => import('tiktok-pixel').then((module) => module.default),
		(TiktokPixel) => void TiktokPixel.init(pixelId, {}),
	);

	return {
		name: 'tiktokPixel',
		start: pixel.load,
		send: (event) => {
			const { name, params } = toVendorEvent(event);
			pixel.use((TiktokPixel) => {
				if (event.name === 'screen_view') {
					TiktokPixel.pageView();
				} else {
					// The package types `track` for TikTok's standard events
					// only; the pixel itself accepts any name.
					(
						TiktokPixel.track as (
							event: string,
							data: Record<string, unknown>,
						) => void
					)(name, params);
				}
			});
		},
	};
}
